import clsx from 'clsx';
import tw from 'twin.macro';
import 'styled-components/macro';

import { ReactComponent as HintErrorIcon } from 'component-lib/atoms/controls/assets/HintError.svg';

const Group = ({ children, className, ...props }: React.ComponentProps<'div'>) => (
  <div className={clsx('leading-loose', className)} {...props}>
    {children}
  </div>
);

const Label = ({ children, ...props }: React.ComponentProps<'label'>) => (
  <label tw="text-base/snug text-primary mb-1" {...props}>
    {children}
  </label>
);

const Hint = ({ error, children, ...props }: React.ComponentProps<'div'> & { error?: boolean }) => (
  <div
    tw="text-base/snug mt-1 text-primary-light flex flex-row items-center gap-1"
    css={error && tw`text-error-dark!`}
    {...props}
  >
    {error && <HintErrorIcon tw="h-2 inline-block" />}
    <span>{children}</span>
  </div>
);

const Optional = () => <span tw="text-primary-light">(optional)</span>;

/** Component to render a form control with a label and hint. */
export const Form = { Group, Label, Hint, Optional };
